export default __webpack_public_path__ + "static/media/five_icon23.77d7695a.png";